<h2 mat-dialog-title class="tw-font-semibold">Create API Key</h2>

<mat-dialog-content class="tw-pt-4 tw-pb-0">
  <form [formGroup]="form" class="tw-space-y-4">
    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
      <mat-hint>Descriptive name for this API key</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Description (Optional)</mat-label>
      <input matInput formControlName="description" />
      <mat-hint>Brief description of this API key's purpose</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="tw-flex tw-justify-between tw-px-6 tw-pb-5 tw-pt-0">
  <button mat-stroked-button (click)="close()">Cancel</button>
  <button
    mat-raised-button
    [disabled]="!form.valid"
    color="primary"
    (click)="save()"
    class="disabled:tw-border-gray-400 disabled:tw-text-gray-400 disabled:tw-cursor-not-allowed">
    Create
  </button>
</mat-dialog-actions>
